module.exports = __webpack_public_path__ + "static/media/din_certco_7P0391.022424c8.png";